import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getShortCloseReasonsQuery = () => {
  return axios.get(apiurl?.getShortCloseReasons);
};

const getShortCloseReasons = () => {
  return useQuery(
    ['getShortCloseReasons'],
    () => getShortCloseReasonsQuery(),
    { refetchOnWindowFocus: false }
  );
};

export default getShortCloseReasons;
